//@flow
import React from 'react';
import ContentRouter from "../../routers/contentRouter";
import Box from "@mui/material/Box";
import Header from "../../components/layout/header/header";
import UserHeader from "../../components/app/userHeader/userHeader";
import Footer from "../../components/layout/footer/footer";

export const TitleContext = React.createContext(null)

const Content = () => {
	const [title, setTitle] = React.useState(null)
	return (
		<TitleContext.Provider
			value={{
				title: title,
				setTitle: setTitle
			}}
		>
			<Box
				component="main"
				className={'content-wrap'}
			>
				<Header/>
				<UserHeader/>
				<ContentRouter/>
				<Footer/>
			</Box>
		</TitleContext.Provider>
	)
}

export default Content;
